import { connect } from 'react-redux';
import { selectors } from '@makemydeal/dr-offer-redux';

import {
    isValidDollarAmount,
    formatDollars,
    formatTermMonths,
    formatApr,
    formatRetailPrice,
    formatMiles
} from '../../utils/formatUtils';
import SummaryUI from './SummaryUI';

export interface ISummaryOwnProps {
    advertisedPriceLabel?: string;
}

export const mapStateToProps = (state, ownProps) => {
    const useNewLeaseVerbiage = ownProps && ownProps.useNewLeaseVerbiage;
    const offerType = selectors.getCurrentOfferType(state);
    const offerSummary = selectors.getOfferSummary(state, offerType);
    const amountFinanced = isValidDollarAmount(offerSummary.amountFinanced) ? formatDollars(offerSummary.amountFinanced) : null;
    const annualMiles = offerSummary.annualMiles ? formatMiles(offerSummary.annualMiles) : 0;
    let apr = offerSummary.term.apr ? formatApr(offerSummary.term.apr) : null;
    const downPayment = isValidDollarAmount(offerSummary.downPayment) ? formatDollars(offerSummary.downPayment) : null;
    const listedPrice = isValidDollarAmount(offerSummary.listedPrice) ? formatDollars(offerSummary.listedPrice) : null;
    const offerPrice = isValidDollarAmount(offerSummary.offerPrice) ? formatDollars(offerSummary.offerPrice) : null;
    const retailPrice = isValidDollarAmount(offerSummary.retailPrice) ? formatRetailPrice(offerSummary.retailPrice) : null;
    const termMonths = formatTermMonths(offerSummary.term.months);
    const totalIncentives = isValidDollarAmount(offerSummary.totalIncentives) ? formatDollars(offerSummary.totalIncentives) : null;
    const financeDownPayment = (offerSummary.downPayment > 0) ? `-${downPayment}` : null;
    const specials = (offerSummary.totalIncentives > 0) ? `-${totalIncentives}` : null;
    const totalDueAtSigning = isValidDollarAmount(offerSummary.dueAtSigning) ? formatDollars(offerSummary.dueAtSigning) : null;
    const netTradeIn = offerSummary.tradeInValue - offerSummary.tradeInAmountOwed;
    const absoluteTradeIn = (netTradeIn > 0) ? netTradeIn : (-1) * netTradeIn;
    const formattedNetTradeIn = isValidDollarAmount(absoluteTradeIn) ? formatDollars(absoluteTradeIn) : null;
    // Display a positive trade-in with a negative sign and vice-versa (no worry: it's pure business)
    const positiveTradeIn = (netTradeIn > 0) ? `-${formattedNetTradeIn}` : null;
    const financeNegativeTradeIn = offerSummary.isFinanceNegativeTradeIn ? `+${formattedNetTradeIn}` : null;
    const dueAtSigningNegativeTradeIn = netTradeIn && !(positiveTradeIn || financeNegativeTradeIn) ?
        `+${formattedNetTradeIn}`
        : null;
    const vehicle = selectors.getVehicleDetails(state);
    const vehicleType = vehicle.type || vehicle.condition || null;

    const isFinanceOfferType = offerType === 'finance';
    const isLeaseOfferType = offerType === 'lease';

    let aprNotAvailableText;
    let downPaymentText = 'Down Payment';
    let dueAtSigningText = 'Total Due At Signing';

    const notAvailableText = 'Not Available';
    const termNotAvailableText = 'Term not available';

    if (isFinanceOfferType) {
        aprNotAvailableText = 'APR not available';
    }
    else {
        apr = null;
    }

    if (isLeaseOfferType && useNewLeaseVerbiage) {
        downPaymentText = 'Cap Cost Reduction';
        dueAtSigningText = 'Cash Down (Out of Pocket)';
    }

    return {
        advertisedPriceLabel: (ownProps && ownProps.advertisedPriceLabel) || 'Advertised Price',
        amountFinanced,
        annualMiles,
        apr,
        aprNotAvailableText,
        downPayment,
        downPaymentText,
        dueAtSigningNegativeTradeIn,
        dueAtSigningText,
        financeDownPayment,
        financeNegativeTradeIn,
        listedPrice,
        notAvailableText,
        offerPrice,
        positiveTradeIn,
        retailPrice,
        isFinanceOfferType,
        specials,
        specialsLabel: ownProps.specialsLabel,
        termMonths,
        termNotAvailableText,
        totalDueAtSigning,
        vehicleType
    };
};

const Summary = connect(
    mapStateToProps
)(SummaryUI);

export default Summary;
